import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import ReactGA from "react-ga4";  // Use react-ga4 for Google Analytics 4
import './NavyPanel.css';

const streamingTexts = ['dating', 'friends', 'training', 'community', 'vibes'];

function NavyPanel({ searchTerm, setSearchTerm }) {
  const [debouncedTerm, setDebouncedTerm] = useState(searchTerm);
  const [typingTimeout, setTypingTimeout] = useState(null);

  // Animation states - start with last word and begin typing immediately
  const [currentWordIndex, setCurrentWordIndex] = useState(streamingTexts.length - 1); // Start with last word
  const [displayText, setDisplayText] = useState(''); // Start empty so it types the word
  const [isDeleting, setIsDeleting] = useState(false); // Start in typing mode

  // Main animation loop
  useEffect(() => {
    const typingSpeed = 100;
    const deletingSpeed = 50;
    const pauseBetweenWords = 1000;
    
    let timeout;

    if (isDeleting) {
      // Deleting phase
      if (displayText.length > 0) {
        timeout = setTimeout(() => {
          setDisplayText(prev => prev.slice(0, -1));
        }, deletingSpeed);
      } else {
        // Finished deleting, move to next word
        timeout = setTimeout(() => {
          setIsDeleting(false);
          setCurrentWordIndex(prev => (prev + 1) % streamingTexts.length);
        }, 100);
      }
    } else {
      // Typing phase
      const targetWord = streamingTexts[currentWordIndex];
      if (displayText.length < targetWord.length) {
        timeout = setTimeout(() => {
          setDisplayText(targetWord.slice(0, displayText.length + 1));
        }, typingSpeed);
      } else {
        // Finished typing, wait then start deleting
        timeout = setTimeout(() => {
          setIsDeleting(true);
        }, pauseBetweenWords);
      }
    }

    return () => clearTimeout(timeout);
  }, [displayText, isDeleting, currentWordIndex]);

  const handleInputChange = (e) => {
    const term = e.target.value;
    setSearchTerm(term);

    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    const timeoutId = setTimeout(() => {
      setDebouncedTerm(term);
    }, 500);

    setTypingTimeout(timeoutId);
  };

  useEffect(() => {
    if (debouncedTerm.trim()) {
      ReactGA.event({
        category: 'Search',
        action: 'Search Term Entered',
        label: debouncedTerm,
      });
      console.log("Sending search term to GA:", debouncedTerm);
    }
  }, [debouncedTerm]);

  return (
    <div className="navy-panel">
      <h1>
        Find running clubs for&nbsp;
        <span className="streaming-text">
          {displayText}
          <span className="cursor">|</span>
        </span>
      </h1>
      <div className="search-bar-container">
        <div className="search-bar-wrapper">
          <FontAwesomeIcon icon={faSearch} className="search-icon" />
          <input
            type="text"
            className="search-bar"
            placeholder="Search by day or club"
            value={searchTerm}
            onChange={handleInputChange}
          />
        </div>
      </div>
    </div>
  );
}

export default NavyPanel;
